export default __webpack_public_path__ + "static/media/poster(brainflix).83d7d003.png";